import React, { FC } from 'react';
import { Container } from '../../components/base/grid';
import { H1 } from '../../components/base/typography';
import Breadcrumbs from '../../components/breadcrumbs';
import DeliverytimeComponent from '../../components/deliverytime';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

interface Props {
	page: IPageViewModel;
}

const Deliverytime: FC<Props> = ({ page }) => {
	return (
		<Container>
			<Breadcrumbs pageId={page.Id} />
			<H1 marginTop="4rem" marginBottom="4rem">
				{page.Name}
			</H1>
			<DeliverytimeComponent />
		</Container>
	);
};

export default pageWrapper(Deliverytime);
